module.exports = __webpack_public_path__ + "img/1314667752.0c59c544.jpg";